import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { StyleProvider } from '@ant-design/cssinjs';
import App from './App';
import { antdTheme } from './config/antdTheme';
import './styles/globals.css';
import api from './lib/axios';
import { useAuthStore } from './stores/authStore';

dayjs.locale('zh-cn');

// Casdoor Callback Handler
const CasdoorCallback: React.FC = () => {
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        console.error('Casdoor login failed:', error);
        navigate('/login');
        return;
      }

      if (code) {
        try {
          // Send code to backend for verification and token generation
          const response = await api.post('/api/auth/casdoor', { code });
          const { user, tokens } = response.data.data;
          setAuth(user, tokens.accessToken, tokens.refreshToken);
          
          // Redirect to stored location or default
          const redirectPath = state || '/projects';
          navigate(redirectPath, { replace: true });
        } catch (error: any) {
          console.error('Casdoor callback failed:', error);
          navigate('/login');
        }
      }
    };

    handleCallback();
  }, [navigate, setAuth]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <div>Processing Casdoor login...</div>
    </div>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider theme={antdTheme} locale={zhCN}>
      <StyleProvider hashPriority="high">
        <BrowserRouter>
          <Routes>
            <Route path="/callback" element={<CasdoorCallback />} />
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </StyleProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
